import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const reference = params.get("reference") || params.get("trxref");
    if (!reference) { setState("error"); return; }
    (async () => {
      try {
        const { data } = await api.get(`/billing/paystack/verify/${reference}`);
        if (data.status === "success") {
          await refresh?.();
          setState("success");
        } else {
          setState("error");
        }
      } catch {
        setState("error");
      }
    })();
  }, [params, refresh]);

  return (
    <div className="min-h-screen bg-[#0A0D0C] grid-bg flex items-center justify-center px-6">
      <div className="card-emerald p-10 max-w-md w-full text-center animate-fade-up" data-testid="paystack-callback">
        {state === "checking" && (<><Loader2 className="w-12 h-12 text-emerald-500 animate-spin mx-auto" /><h1 className="font-display text-2xl font-bold mt-6">Verifying your payment…</h1><p className="text-sm text-muted-foreground mt-2">One moment while we confirm with Paystack.</p></>)}
        {state === "success" && (<><CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto" /><h1 className="font-display text-2xl font-bold mt-6">Payment confirmed!</h1><p className="text-sm text-muted-foreground mt-2">Your QwikLogs access is now active. Thank you.</p><Button onClick={() => navigate("/app")} className="mt-6 bg-emerald-500 hover:bg-emerald-600 text-[#062217] font-semibold" data-testid="callback-continue-btn">Go to dashboard</Button></>)}
        {state === "error" && (<><XCircle className="w-14 h-14 text-red-400 mx-auto" /><h1 className="font-display text-2xl font-bold mt-6">Payment not confirmed</h1><p className="text-sm text-muted-foreground mt-2">We couldn't verify this payment. If you were charged, it will reconcile automatically.</p><Link to="/app/billing"><Button className="mt-6" variant="outline">Back to billing</Button></Link></>)}
      </div>
    </div>
  );
}
